import { useQuery } from 'react-query';

import { getLogicCheckerConfiguration as queryFn } from 'api/endPoints/getLogicCheckerConfiguration';

export const useQueryGetLogicCheckerConfiguration = (params: { contractId?: number }) => {
    return useQuery<ILogicCheckerConfigurationResponse[], QueryError>(
        ['getLogicCheckerConfiguration', params],
        () => queryFn(params),
        {
            enabled: Boolean(params.contractId),
        },
    );
};

export interface ILogicCheckerConfigurationResponse {
    validationId: number;
    validationName: string;
    thresholds: {
        threshold_id: number;
        threshold_description: string | null;
        upper_limit_value: number;
        upper_limit_operator: '>';
        lower_limit_value: number;
        lower_limit_operator: '<=';
        units: '%';
        color_low_level: 'PASS' | 'FAIL';
        color_high_level: 'PASS' | 'FAIL';
        maxValue: number;
        minValue: number;
        step: number;
    }[];
    mandatory: boolean;
}
